import { ReactElement, ReactNode, useEffect, useRef, useState } from "react";
import { Flex, Box } from "@chakra-ui/react";
import { Footer } from "../atoms/CommonLayout/Footer";

type BottomNavLayoutProps = {
  children: ReactNode;
};

export function BottomNavLayout({
  children,
}: Readonly<BottomNavLayoutProps>): ReactElement {
  const footerRef = useRef<HTMLDivElement>(null);
  const [footerHeight, setFooterHeight] = useState(0);

  useEffect(() => {
    if (footerRef.current) {
      setFooterHeight(footerRef.current.offsetHeight);
    }
  }, []);

  return (
    <Flex h="full" minW="full" direction="column" justify="center">
      <Flex
        flex={1}
        direction="column"
        overflowY="auto"
        align="center"
        pb={`${footerHeight}px`}
      >
        {children}
      </Flex>
      <Box
        ref={footerRef}
        position="fixed"
        bottom={0}
        left={0}
        right={0}
        zIndex={1000}
      >
        <Footer />
      </Box>
    </Flex>
  );
}
